var disposed = false
var normalizeComponent = require("!../../../../cas/node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}]]}!../../../../cas/node_modules/vue-loader/lib/selector?type=script&index=0!./Link.vue")
/* template */
var __vue_template__ = require("!!../../../../cas/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3b7b72c2\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../cas/node_modules/vue-loader/lib/selector?type=template&index=0!./Link.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "default-js/js/components/common/Link.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3b7b72c2", Component.options)
  } else {
    hotAPI.reload("data-v-3b7b72c2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ../default-js/js/components/common/Link.vue
// module id = 267
// module chunks = 17